module.exports = __webpack_public_path__ + "img/logo-blue-papyrus.c3aab5b2.svg";